import { createLucideIcon } from "lucide-react"
export const Nudge = createLucideIcon("pointer", [
  [
    "path",
    {
      d: "M 10 12 L 13 9.5",
      key: "1deszh",
    },
  ],
  [
    "path",
    {
      d: "M 11 3 C11 7 6 8.119 6 12",
      key: "124n2f",
    },
  ],
  [
    "path",
    {
      d: "M 13 14.5 L 10 12",
      key: "1txrf8",
    },
  ],
  [
    "path",
    {
      d: "M 19 12 L 10 12",
      key: "7ib4fm",
    },
  ],
  [
    "path",
    {
      d: "M 6 12 C6 15.883 11 17 11 21",
      key: "16i39b",
    },
  ],
])
